<template>
  <div class="footerimg"
       v-if="foot">
    <div class="footerText">
      <div class="footerBox"
           v-show="lookBtn">
        <div class="footerBoxImg"
             @mouseover="Mouseover()"
             @mouseleave="Mouseleave()">
          <img src="../static/images/二维码 (4).png"
               alt="">
        </div>
        <div class="footerBoxImg"><img src="../static/images/收藏标签 (1).png"
               alt=""></div>
        <div class="footerBoxImg"><img @click="toTop"
               src="../static/images/回到顶部.png"
               alt=""></div>
        <div class="downerweima"
             v-show="skjhash">
          <div class="downtext">
            <div id="qrcodeppT"></div>
            <div class="downtextspan">扫一扫，访问本页手机版</div>
          </div>
        </div>
      </div>
      <div class="Links"></div>
      <!--      <div class="footerologo">
        <img src="../static/images/底部万域天游.png"
             alt="">
      </div> -->
      <!-- <div class="transverse"></div> -->
      <!-- <div class="Partner"> -->
      <!-- <div class="Partnerbox cooperation">
          渠道合作
        </div>
        <div class="cooperation">
          商务合作
        </div>
        <div class="Partnerbox cooperation"
             @click="gowe">
          联系我们
        </div> -->
      <!-- </div> -->
      <div class="text">
        <p>作品版权归作者所有，如果侵犯了您的版权，请联系我们，本站将在3个工作日内删除。</p>
        <p>温馨提示：抵制不良游戏，拒绝盗版游戏，注意自我保护，谨防受骗上当，适度游戏益脑，沉迷游戏伤身，合理安排时间，享受健康生活</p>
        <p>网站备案/许可证号：<a style="color:#666666"
             href="https://beian.miit.gov.cn">{{configInfo.filing}}</a> | 手机版 | 举报邮箱：{{configInfo.email}} </p>
      </div>
      <p class="text tectfooter">{{configInfo.copyright}}</p>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  name: 'footers',
  data () {
    return {
      lookBtn: false,
      skjhash: false,
      foot: true,
      fotterData: '',
      cValues: '',
      configInfo: ''
    }
  },
  mounted () {
    window.addEventListener("scroll", this.bntshow);
    let loginData = new FormData();
    loginData.append("channel", this.$RouterDatac.c)
    this.$apiFun.tailConfiguration(loginData).then((res) => {
      this.fotterData = res.data
      this.configInfo = res.data.configInfo
    })
    this.qrcode()
  },
  methods: {
    gowe () {
      this.$router.push('/customer');
    },
    toTop () {
      //  设置一个定时器
      const upRoll = setInterval(() => {
        const top = document.documentElement.scrollTop // 每次获取页面被卷去的部分
        const speed = Math.ceil(top / 10) // 每次滚动多少 （步长值）
        if (document.documentElement.scrollTop > 0) {
          document.documentElement.scrollTop -= speed // 不在顶部 每次滚动到的位置
        } else {
          clearInterval(upRoll) // 回到顶部清除定时器
        }
      }, 20)
    },
    bntshow (e) {
      let scrollTop = e.target.scrollingElement.scrollTop
      if (scrollTop > 800) {
        this.lookBtn = true
      } else {
        this.lookBtn = false
      }
    },
    Mouseover () {
      this.skjhash = true
    },
    Mouseleave () {
      this.skjhash = false
    },
    //  生成二维码  安卓
    qrcode () {
      new QRCode("qrcodeppT", {
        width: 144, // 二维码宽度，单位像素
        height: 144, // 二维码高度，单位像素
        text: window.location.href,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    }
  }
}
</script>

<style scoped>
.footerimg {
  width: 100%;
  height: 220px;
  background: url(../static/images/底部背景.png);
  z-index: 9999999999;
}
.footerBoxImg img {
  width: 50px;
  height: 50px;
  margin-top: 10px;
}
.footerBox {
  display: flex;
  width: 50px;
  height: 200px;
  position: fixed;
  top: 435px;
  right: 200px;
  flex-direction: column;
}
.footerText {
  width: 1200px;
  margin: 0 auto;
  height: 10px;
  position: relative;
}
.Links {
  padding: 25px 0px 20px 0;
  color: #666666;
  font-size: 14px;
}
.transverse {
  width: 1200px;
  height: 1px;
  background-color: #999999;
  margin-top: 30px;
}
.Partner {
  display: flex;
  margin: 20px auto;
  width: 236px;
}
.cooperation {
  padding: 0 10px;
  color: #666666;
}
.Partnerbox {
  border: 2px #666666 solid;
  border-top: transparent;
  border-bottom: transparent;
}
.downerweima {
  position: relative;
}
.text {
  text-align: center;
  font-size: 12px;
  line-height: 28px;
  color: #666666;
}
.tectfooter {
  margin-top: 10px;
}
.downtext #qrcode {
  position: absolute;
  width: 160px;
  height: 160px;
  right: 50px;
  top: -170px;
}
#qrcodeppT {
  width: 160px;
  height: 160px;
  position: absolute;
  z-index: 999;
  text-align: center;
  top: -170px;
  right: 50px;
}
.downtextspan {
  width: 160px;
  position: absolute;
  right: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/footers.vue